import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../redux/axios";
import { getBrowserGMTOffset } from "../../../../lib/utility";

const initialState = {
  scheduleEditData: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
  pageSize: 10,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",

  deleteSchedule: {},
  isSuccessDeleteSchedule: false,
  isErrorDeleteSchedule: false,
  isErrorMessageDeleteSchedule: "",

  editSchedule: {},
  isFetchingEdit: false,
  isSuccessEditSchedule: false,
  isErrorEditSchedule: false,
  isErrorMessageEditSchedule: "",

  isFetchingUpdate: false,
  updateSchedule: {},
  isSuccessUpdateSchedule: false,
  isErrorUpdateSchedule: false,
  isErrorMessageUpdateSchedule: "",
};

export const getScheduleData = createAsyncThunk(
  "schedule/get-all-schedule", 
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      let url = `/sms/listSchedule`;

      if (typeof udata === "string") {
        url += (udata.startsWith("?") ? udata : `?${udata}`);
      } else if (udata && typeof udata === "object") {
        const params = new URLSearchParams();
        const page =
          udata.page !== undefined
            ? udata.page
            : udata.pageNumber !== undefined
            ? udata.pageNumber
            : undefined;
        const size =
          udata.size !== undefined
            ? udata.size
            : udata.pageSize !== undefined
            ? udata.pageSize
            : undefined;

        if (page !== undefined && page !== null) {
          params.append("page", page);
        }
        if (size !== undefined && size !== null) {
          params.append("size", size);
        }

        const sortBy = udata.sortBy || "createdOn";
        params.append("sortBy", sortBy);

        const sortDirection = udata.sortDirection || "desc";
        params.append("sortDirection", sortDirection);

        if (udata.startDate) params.append("startDate", udata.startDate);
        if (udata.endDate) params.append("endDate", udata.endDate);
        const toGmt = udata.toGmt || getBrowserGMTOffset();
        if (toGmt) params.append("toGmt", toGmt);
        if (udata.clientId) params.append("clientId", udata.clientId);
        if (udata.search) params.append("search", udata.search);

        const qs = params.toString();
        if (qs) url += `?${qs}`;
      }

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      console.error("err ===>", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const deleteScheduleData = createAsyncThunk(
  "schedule/delete-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const response = await axios.delete(
        `/sms/abort/schedule?scheduleId=${udata.id}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      let data = response;
      if (response.status === 200) {
        return data.data;
      } else if (response.status === 201) {
        return data.data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getEditScheduleData = createAsyncThunk(
  "schedule/edit-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        `sms/edit/schedule?scheduleId=${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const updateScheduleData = createAsyncThunk(
  "schedule/update-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(
        `sms/modify`,
        
        udata.formData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const sendScheduleData = createAsyncThunk(
  "schedule/update-schedule",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.post(
        `sms/send-now`,
        udata.formData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    clearStateSchedule: (state, { payload }) => {
      state.scheduleEditData = [];
      state.totalItems = 0;
      state.totalPages = 0;
      state.currentPage = 0;
      state.pageSize = 10;
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
    },
    clearStateDeleteSchedule: (state, { payload }) => {
      state.deleteSchedule = {};
      state.isFetching = false;
      state.isSuccessDeleteSchedule = false;
      state.isErrorDeleteSchedule = false;
      state.isErrorMessageDeleteSchedule = "";
    },
    clearStateEditSchedule: (state, { payload }) => {
      state.editSchedule = {};
      state.isFetching = false;
      state.isSuccessEditSchedule = false;
      state.isErrorEditSchedule = false;
      state.isErrorMessageEditSchedule = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduleData.fulfilled, (state, action) => {
        const payloadData = action.payload?.data;
        if (Array.isArray(payloadData)) {
          state.scheduleEditData = payloadData;
          state.totalItems = payloadData.length;
          state.totalPages = 1;
          state.currentPage = 0;
          state.pageSize = payloadData.length || 10;
        } else if (payloadData && typeof payloadData === "object") {
          state.scheduleEditData = Array.isArray(payloadData.data)
            ? payloadData.data
            : [];
          state.totalItems =
            payloadData.totalElements !== undefined &&
            payloadData.totalElements !== null
              ? payloadData.totalElements
              : state.scheduleEditData.length;
          state.totalPages = payloadData.totalPages ?? 1;
          state.currentPage = payloadData.pageNumber ?? 0;
          state.pageSize = payloadData.pageSize ?? 10;
        } else {
          state.scheduleEditData = [];
          state.totalItems = 0;
          state.totalPages = 0;
          state.currentPage = 0;
          state.pageSize = 10;
        }
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getScheduleData.rejected, (state, action) => {
        state.scheduleEditData = [];
        state.totalItems = 0;
        state.totalPages = 0;
        state.currentPage = 0;
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      
      .addCase(getEditScheduleData.fulfilled, (state, action) => {
        state.editSchedule = action.payload;
        state.isFetchingEdit = false;
        state.isSuccess = true;
      })
      .addCase(getEditScheduleData.pending, (state) => {
        state.isFetchingEdit = true;
      })
      .addCase(getEditScheduleData.rejected, (state, action) => {
        state.editSchedule = {};
        state.isFetchingEdit = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      
      .addCase(deleteScheduleData.fulfilled, (state, action) => {
        state.deleteSchedule = action.payload;
        state.isFetching = false;
        state.isSuccessDeleteSchedule = true;

        if (Array.isArray(state.scheduleEditData) && state.scheduleEditData.length === 1) {
          state.scheduleEditData = [];
        }
      })
      .addCase(deleteScheduleData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteScheduleData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorDeleteSchedule = true;
        state.isErrorMessageDeleteSchedule = action.payload
          ? action.payload.message
          : "Internal error";
      })
      
      .addCase(updateScheduleData.fulfilled, (state, action) => {
        state.updateSchedule = action.payload;
        state.isFetchingUpdate = false;
        state.isSuccessUpdateSchedule = true;
        state.isErrorMessageUpdateSchedule = action.payload.data;
      })
      .addCase(updateScheduleData.pending, (state) => {
        state.isFetchingUpdate = true;
      })
      .addCase(updateScheduleData.rejected, (state, action) => {
        state.isFetchingUpdate = false;
        state.isErrorUpdateSchedule = true;
        state.isErrorMessageUpdateSchedule = action.payload
          ? action.payload.message
          : "Internal error";
      });
  },
});

export const {
  clearStateSchedule,
  clearStateDeleteSchedule,
  clearStateEditSchedule,
} = scheduleSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateSchedule());
  };
}

export function clearStateDelete() {
  return async (dispatch) => {
    dispatch(clearStateDeleteSchedule());
  };
}

export function clearStateEdit() {
  return async (dispatch) => {
    dispatch(clearStateEditSchedule());
  };
}

export const scheduleEditSelector = (state) => state.scheduleEdit;

export default scheduleSlice.reducer;
